import { api } from '../api';
export default {
  /** Best-effort backend audit log entry. Don't block UX on failure. */
  logout: () => api.post('/v1/auth/logout').catch(() => null),
};
